import { Directive, HostListener, Input } from '@angular/core';
import { NgControl } from '@angular/forms';

@Directive({
    selector: '[appTwoDecimal]',
    standalone: false
})
export class TwoDecimalDirective {
  @Input() appTwoDecimal: boolean = true;
  /** Max digits after the dot. Defaults to 2; the Digital Assets BTC Quantity passes 3. */
  @Input() decimalPlaces: number = 2;

  constructor(private ngControl: NgControl) {}

  // Only to block dot as first character
  @HostListener('keypress', ['$event'])
  onKeyPress(event: KeyboardEvent): void {
    const inputChar = event.key;
    const input = event.target as HTMLInputElement;

    // Block dot as first character
    if (input.value.length === 0 && inputChar === '.') {
      event.preventDefault();
    }
  }

  @HostListener('input', ['$event'])
  onInput(event: Event): void {
    if (!this.appTwoDecimal) return;

    const input = event.target as HTMLInputElement;
    let value = input.value;

    const regex = new RegExp(`^\\d*\\.?\\d{0,${this.decimalPlaces}}$`);

    if (!regex.test(value)) {
      const parts = value.split('.');
      if (parts.length > 1) {
        value = `${parts[0]}.${parts[1].slice(0, this.decimalPlaces)}`;
      }

      value = value.replace(/[^0-9.]/g, '');
      input.value = value;
      this.ngControl.control?.setValue(value);
    }
  }
}
